// The address and title of the page a person was on before the one they are on
// now. The library's request form sends it as `page_url` and `page_title`: "the
// address the person was at when they chose + New ticket" (contract section 13).
// The app shell calls `rememberAddress` just before it moves to a new route, for a
// link or a button and for Back and Forward. It is also kept in sessionStorage so a
// reload of the form still knows where the person came from.

const KEY = 'cos.previous-address';

let last: { url: string; title: string } | null = null;

export function rememberAddress(url: string, title: string): void {
	last = { url, title };
	try { sessionStorage.setItem(KEY, JSON.stringify(last)); } catch { /* storage refused: memory still has it */ }
}

export function addressBeforeNow(): { url: string; title: string } | null {
	if (last) return last;
	try {
		const raw = sessionStorage.getItem(KEY);
		if (raw) {
			const v = JSON.parse(raw) as { url?: unknown; title?: unknown };
			if (typeof v.url === 'string' && v.url) return { url: v.url, title: typeof v.title === 'string' ? v.title : '' };
		}
	} catch { /* nothing kept */ }
	return null;
}

export function _resetAddressForTests(): void {
	last = null;
	try { sessionStorage.removeItem(KEY); } catch { /* nothing to remove */ }
}
